let inject = ['$scope', '$uibModalInstance', 'responses'];

class PqrsInnerModalController {
  constructor ($scope,$uibModalInstance, responses) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.responses = responses;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

PqrsInnerModalController.$inject = inject;

export default PqrsInnerModalController;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-detail/pqrs-inner-modal/pqrs-inner-modal.controller.js
 **/